import {
  Icon,
  Footer,
  HeaderPartner,
  Banner,
  Row,
  Col,
  Picture,
  Typography,
} from 'darrius';

import { formData } from '../../locales/pt-BR';

import {
  HeadContent,
  FormLead,
  Benefits,
  Depoiments,
  HowMuch,
  HowWorks,
  WhyUs,
} from '../../components';

import { type TStaticContent } from '../@interfaces';

import styles from './ProspectTemplatePartner.module.scss';

interface IProspectTemplateHomePartnerProps {
  staticContent: TStaticContent;
  partner: '';
}

export default function IProspectTemplateHomePartner(
  props: IProspectTemplateHomePartnerProps
) {
  const { staticContent, partner } = props;
  const { footerContent } = staticContent;

  const logo = {
    link: '/',
    imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/partners/${partner}.svg`,
    alt: `Logo do parceiro ${partner}`,
  };

  const partnerName = partner
    .replace(/[^A-Za-z0-9]/g, ' ')
    .replace(/^./, (str) => str.toUpperCase());

  const partnerCuponName = partnerName.toUpperCase().replace(/\s/g, '') + '10';

  return (
    <div className={styles['home-partner']}>
      <HeadContent
        metaTitle="GetNinjas | Orçamento de Profissionais Confiáveis no GetNinjas.com.br"
        slug={partner}
        metaDescription="Encontre profissionais confiáveis para pintar, reformar, traduzir um texto, te ensinar matemática, ou também passear com seu cachorro no GetNinjas"
        type="prospect:home-partner"
      />
      <HeaderPartner logo={logo} brandLink={process.env.NEXT_PUBLIC_HOST} />

      <Banner
        as="section"
        className={`${styles['background-hero']} ${styles.register}`}
      >
        <Row className="middle-sm">
          <Col className="col-sm-12">
            <Row>
              <Col className="col-sm-12 col-md-6 col-lg-6 space-bottom">
                <Typography.Title className={styles['title-hero']}>
                  Consiga <span className="contrast">mais clientes</span> direto
                  do seu celular
                </Typography.Title>

                <Typography.Text>
                  Cadastre-se e ganhe um desconto exclusivo para clientes da{' '}
                  {partnerName} com o cupom{' '}
                  <span className={styles['fake-tag']}>{partnerCuponName}</span>
                </Typography.Text>

                <Icon
                  alt="Icone de verificado"
                  src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/icon-check.svg`}
                  text="+450 mil pedidos solicitados por mês"
                />
                <div className={styles['form-group']}>
                  <FormLead
                    order="first_form"
                    content={formData}
                    direction="vertical"
                    buttonText="Quero garantir meu desconto"
                    showLgpdCheckbox
                  />
                </div>
              </Col>
              <Col
                className={`${styles['image-hero__section']} col-sm-12 col-md-6 col-lg-6 space-top hide-mobile`}
              >
                <Picture
                  className={`full space-top ${styles['image-hero']}`}
                  src={{
                    sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/partner-banner.svg`,
                    md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/partner-banner.svg`,
                    lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/partner-banner.svg`,
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Banner>

      <Benefits />

      <HowWorks />

      <HowMuch />

      <WhyUs />

      <Depoiments />

      <Footer data={footerContent} />
    </div>
  );
}
